export default {
  delivery_orders: {
    'some data was not found': 'invoice.warningMessage.someDataWasNotFound',
    'found duplicate id': 'invoice.warningMessage.doubleDO',
    'customer ids is not equal': 'delivery.invoice.warningMessage.billingSameCustomer',
    'invoice_id': {
      'already invoiced': 'delivery.invoice.warningMessage.deleteInvoiceToCreateBill'
    },
    'status': {
      'DRAFT': 'delivery.invoice.warningMessage.doDraftCanceledCantBilled',
      'CANCELED': 'delivery.invoice.warningMessage.doDraftCanceledCantBilled'
    },
    'external_reference': {
      'not internal': 'invoice.warningMessage.notInternalDo'
    },
  },
  'unauthorized external reference': 'delivery.provider.failedToConnectAccountMsg',
  'items': {
    'the field must be at least 1': 'invoice.warningMessage.itemIsRequired',
    'found unregistered vehicle': 'invoice.warningMessage.unregisteredVehicle',
    'drlivery order not match': 'invoice.warningMessage.deliveryOrderNotMatch'
  },
  'customer' : {
    'not found' : 'invoice.warningMessage.customerNotFound'
  },
  'due_date': {
    'value should be greater or equal to transaction_date': 'invoice.warningMessage.dueDateShouldBeGreater',
    'the field is required': 'invoice.warningMessage.dueDateIsRequired'
  }
}